export default "__VITE_ASSET__bgFkJzCz__"